import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-plans',
  templateUrl: './pricing-plans.component.html',
  styleUrls: ['./pricing-plans.component.css']
})
export class PricingPlansComponent implements OnInit {

  @Input() packages;
  @Input() myRouteId;
  packagesObjFiltered;

  cards = [
    {
      title: 'Estudios, cursos y becas...',
      section: 'academic',
      category: 'Acedémico',
      img: "assets/voyjaleas/academic.jpeg",
      selected: true,
    }
  ];

  studyPackages = [
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "7",
        "package_type": "basic",
        "name": "Basic",
        "price": "99",
        "product": "Consultoría y seguimiento para la obtención del visado de estudiante."
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "7",
        "package_type": "basic",
        "name": "Basic",
        "price": "99",
        "product": "Asistencia para la contratación de un seguro médico."
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "7",
        "package_type": "basic",
        "name": "Basic",
        "price": "99",
        "product": "Guía básica para preparar la maleta\r\n(estaciones, vestimenta)"
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "7",
        "package_type": "basic",
        "name": "Basic",
        "price": "99",
        "product": "Asesoría y acompañamiento en\r\nbúsqueda de vuelos"
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "7",
        "package_type": "basic",
        "name": "Basic",
        "price": "99",
        "product": "Atención remota vía email + 1\r\nvideollamada de 30 minutos"
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "8",
        "package_type": "premium",
        "name": "Premium",
        "price": "129",
        "product": "Asesoría para realizar un presupuesto mensual"
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "8",
        "package_type": "premium",
        "name": "Premium",
        "price": "129",
        "product": "Guía de movilidad en Madrid"
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "8",
        "package_type": "premium",
        "name": "Premium",
        "price": "129",
        "product": "Consultoría básica de búsqueda de\r\nhospedaje en la ciudad de elección\r\n(recomendaciones de lugares,\r\nconfiguración de alertas, agencias, etc)"
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "8",
        "package_type": "premium",
        "name": "Premium",
        "price": "129",
        "product": "Atención remota avanzada\r\n(email + WhatsApp + 3 videollamadas de 30 min c/u)"
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "8",
        "package_type": "premium",
        "name": "Premium",
        "price": "129",
        "product": "3 videollamadas de seguimiento\r\n\r\n(30 min c/u)"
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "9",
        "package_type": "full",
        "name": "Full Assistance",
        "price": "179",
        "product": "Guía avanzada para vivir en Madrid\r\n(movilidad, gastronomía, cultura, deporte,\r\n\r\nlugares de interés)"
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "9",
        "package_type": "full",
        "name": "Full Assistance",
        "price": "179",
        "product": "Consultoría avanzada de búsqueda de\r\nhospedaje en la ciudad de elección\r\n(Hoja de análisis de pisos)\r\n"
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "9",
        "package_type": "full",
        "name": "Full Assistance",
        "price": "179",
        "product": "Acompañamiento a la llegada a España\r\n(cuenta bancaria, tarjeta SIM e internet en\r\ncasa, NIE, empadronamiento)"
    },
    {
        "description": "",
        "paid": "1",
        "FK_ID_package_chosen": "8",
        "id": "9",
        "package_type": "full",
        "name": "Full Assistance",
        "price": "179",
        "product": "Atención avanzada (email + WhatsApp + 6\r\nvideollamadas de 30 min c/u)"
    }
  ];

  constructor() { }

  ngOnInit(): void {
    this.packages = this.studyPackages;
  }

  goToPage(page){
/*     this.router.navigateByUrl(page); */
  }

  getOldPrice(price){
    price = parseInt(price) + 20;
    return price;
  }

  getProjectDataObject(variableName){
    let buff;
/*     variableName === 'faqs'? buff = this.faqs : null;
    variableName === 'testimonials'? buff = this.testimonials : null;
    variableName === 'iPhonePhotos'? buff = this.iPhonePhotos : null; */
    variableName === 'studyPackages'? buff = this.studyPackages : null;
    return buff;
  }

  getCssClass(pack){
    if(pack.name == "Premium"){
      return 'card active';
    }else{
      return 'card shadow';
    }
  }

  addProduct(newProduct,list){
    if(list){
      list.push(newProduct);
    }else{
      list = [];
      list.push(newProduct);
    }
    return list;
  }
  
  getPackagesByType(){
    let basic = {};
    let premium = {};
    let full = {};
    
    if(this.packages){
      for(let item of this.packages){
        if(item.package_type === 'basic'){
            basic['products'] = this.addProduct(item.product,basic['products']);
            basic['price'] = item.price;
            basic['paid'] = item.paid;
            basic['id'] = item.id;
            basic['name'] = item.name;
            basic['FK_ID_package_chosen'] = item.FK_ID_package_chosen;
        }
        if(item.package_type === 'premium'){
          premium['products'] = this.addProduct(item.product,premium['products']);
          premium['price'] = item.price;
          premium['paid'] = item.paid;
          premium['id'] = item.id;
          premium['name'] = item.name;
          premium['FK_ID_package_chosen'] = item.FK_ID_package_chosen;
        }
        if(item.package_type === 'full'){
          full['products'] = this.addProduct(item.product,full['products']);
          full['price'] = item.price;
          full['paid'] = item.paid;
          full['id'] = item.id;
          full['name'] = item.name;
          full['FK_ID_package_chosen'] = item.FK_ID_package_chosen;
        }
      }
      this.packagesObjFiltered = [
        basic,
        premium,
        full
      ];
      return this.packagesObjFiltered;
    }else{
      return []
    }
  }

}
